import type { AppBarAdStatus, AppBarVariant } from "~/components/app-bar/helpers";
import { PageType } from "~/lib/router/enums";

export const pathname = "/section";

export const page = {
  route(
    query: QueryParameters<{
      appBarAdStatus?: AppBarAdStatus;
      appBarVariant?: AppBarVariant;
      entityId: string;
      slide: Slide;
    }>,
  ) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Section },
    };
  },
  slideFromSuffix(suffix?: string): Slide {
    switch (suffix) {
      case "opinion":
        return "opinion";
      case "explore":
        return "explore";
      default:
        return "main";
    }
  },
  suffix: ["explore", "opinion"] as const,
};

export function queues(entityId: string) {
  return {
    articlesQueueName: `section_top_${entityId}`,
    topicsQueueName: `related_topics_${entityId}`,
  };
}

type Slide = "main" | "opinion" | "explore";
